import React from 'react'

function escapeRegExp(string: string): string {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
}

/**
 * Highlights occurrences of any provided variable(s) in the input text.
 * @param input - The text to process.
 * @param variables - Array of variables to highlight.
 * @returns A React node with all found variables highlighted.
 */
export const highlightVariables = (input: string, variables: string[]): React.ReactNode => {
  if (!variables || variables.length === 0) {
    return input
  }

  // Create a regex that matches any of the variables
  const regex = new RegExp(`(${variables.map((v) => escapeRegExp(v)).join('|')})`, 'g')
  const parts = input.split(regex)

  return parts.map((part, index) =>
    variables.includes(part) ? (
      <span key={index} style={{ fontWeight: 500, fontStyle: 'italic' }}>
        {part}
      </span>
    ) : (
      part
    ),
  )
}
